import type { SVGProps } from 'react'
const SvgSyKeyAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M3 11c0-3.771 0-5.657 1.172-6.828S7.229 3 11 3h2c3.771 0 5.657 0 6.828 1.172S21 7.229 21 11v2c0 3.771 0 5.657-1.172 6.828S16.771 21 13 21h-2c-3.771 0-5.657 0-6.828-1.172S3 16.771 3 13z"
		/>
		<path d="M8.5 9C7.125 9 6 10.125 6 11.5S7.125 14 8.5 14s2.5-1.125 2.5-2.5S9.875 9 8.5 9m0 1c.834 0 1.5.666 1.5 1.5S9.334 13 8.5 13 7 12.334 7 11.5 7.666 10 8.5 10" />
		<path d="M10.5 11a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5H15v1.5a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5V12h1v1.5a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-1.85a.66.66 0 0 0-.65-.65H15.5z" />
	</svg>
)
export default SvgSyKeyAlt
